const urlEncodedSpaceRE = /\+/g;

function urlDecode(str: string): string {
    // spec says space should be encoded as '+'
    str = str.replace(urlEncodedSpaceRE, " ");
    return decodeURIComponent(str);
}

interface QueryParams {
    [key: string]: string | string[] | null;
}

interface AddFunction {
    (key: string, value: any): void;
}

const formUrlEncoder = {
    read: function (str: string): QueryParams {
        const obj: QueryParams = {};
        str.split("&").forEach(function (entry: string) {
            const pair = entry.split("=");
            const name = urlDecode(pair[0]);
            const value = pair.length === 2 ? urlDecode(pair[1]) : null;

            if (name in obj) {
                if (!Array.isArray(obj[name])) {
                    // convert to an array, preserving current value
                    obj[name] = [obj[name] as string];
                }
                (obj[name] as string[]).push(value as string);
            } else {
                obj[name] = value;
            }
        });
        return obj;
    },

    write: function (obj: QueryParams): string {
        return objectToQueryString(obj);
    },
};

function objectToQueryString(a: QueryParams | any[]): string {
    const s: string[] = [];
    const r20 = /%20/g;

    const add: AddFunction = function (key: string, value: any): void {
        // If value is a function, invoke it and return its value
        value = typeof value === "function" ? value() : value == null ? "" : value;
        s.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    };

    if (Array.isArray(a)) {
        for (const name in a) {
            add(name, a[name]);
        }
    } else {
        for (const prefix in a) {
            buildParams(prefix, a[prefix], add);
        }
    }

    return s.join("&").replace(r20, "+");
}

function buildParams(prefix: string, obj: any, add: AddFunction): void {
    const rbracket = /\[\]$/;

    if (Array.isArray(obj)) {
        for (let i = 0, l = obj.length; i < l; i++) {
            if (rbracket.test(prefix)) {
                add(prefix, obj[i]);
            } else {
                buildParams(
                    prefix + "[" + (typeof obj[i] === "object" ? i : "") + "]",
                    obj[i],
                    add
                );
            }
        }
    } else if (typeof obj === "object") {
        // Serialize object item.
        for (const name in obj) {
            buildParams(prefix + "[" + name + "]", obj[name], add);
        }
    } else {
        // Serialize scalar item.
        add(prefix, obj);
    }
}

export default formUrlEncoder;